import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import FilesAndDirectoriesService, { Type } from '../../../services/FilesAndDirectoriesService'

type DuplicateItemPayload = {
  organization: string
  path: string
  type: Type
}

export const useDuplicateItem = (directoryPath?: string) => {
  const { org, project } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, DuplicateItemPayload>({
    mutationKey: ['duplicate-project-item'],
    mutationFn: ({ organization, path, type }) => FilesAndDirectoriesService.duplicate(organization, path, type),
    onSuccess: () => {
      directoryPath
        ? queryClient.invalidateQueries({ queryKey: ['directory-content', org, project, directoryPath] })
        : queryClient.invalidateQueries({ queryKey: ['project-content', org, project] })
    },
  })
}
